"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestResponse = void 0;
class BadRequestResponse {
}
exports.BadRequestResponse = BadRequestResponse;
//# sourceMappingURL=bad-request.response.js.map